import styled from 'styled-components'

import { SubMenuType } from '@application/Types/HeaderTypes'
import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import { Link } from '@src/Application/Interfaces/Atoms/Link'
import { HeaderThemeModeType, NavigationThemeType } from '@src/Application/Types/ComponentTypes'

export const NavItemLinkLabel = styled.div`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
    padding: 20px 8px;
    position: relative;
    cursor: pointer;

    &::after {
        display: none;
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 0;
        height: 5px;
        background: ${(props) => props.theme.color.a500};
    }

    @media ${(props) => props.theme.query.desktop} {
        padding: 30px 10px;
        ${(props) => props.theme.typo.bodyM};
    }
`

export const NavItemLink = styled(Link)`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    display: block;
    color: ${(props) => props.theme.color.black};
    padding: 20px 8px;
    text-decoration: none;
    position: relative;

    &::after {
        display: none;
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 0;
        height: 5px;
        background: ${(props) => props.theme.color.a500};
    }

    @media ${(props) => props.theme.query.desktop} {
        padding: 30px 10px;
        ${(props) => props.theme.typo.bodyM};
    }
`

export const NavItemButton = styled(ButtonBase)`
    margin-left: 8px;
    margin-right: 8px;

    @media ${(props) => props.theme.query.desktop} {
        margin-top: 18px;
    }
`

export const Navbar = styled.div<{ $mode: HeaderThemeModeType; $type: NavigationThemeType }>`
    list-style: none;
    display: flex;
    position: relative;

    ${NavItemLinkLabel}, ${NavItemLink} {
        ${(props) => props.$mode === 'Dark' && `color: ${props.theme.color.white};`}
        ${(props) => props.$mode === 'Light' && `color: ${props.theme.color.black};`}
        ${(props) => props.$mode === 'Light' && props.$type === 'Minimal' && `color: ${props.theme.color.p500};`}
        ${(props) => props.$mode === 'Transparent' && `color: ${props.theme.color.white};`}
    }
`

export const SubMenuColumn = styled.div`
    margin-right: 50px;

    &:last-child {
        margin-right: 0;
    }

    @media ${(props) => props.theme.query.mobile} {
        margin-right: 0;
        margin-bottom: 30px;
    }
`

export const SubMenuItem = styled.div`
    @media ${(props) => props.theme.query.mobile} {
        margin-bottom: 20px;
    }
`

export const SubMenuWrapper = styled.div<{ type: SubMenuType }>`
    display: none;
    position: absolute;
    top: 100%;
    left: -15px;
    /*! @noflip */
    left: 0px;
    /*! @noflip */
    right: auto;
    border-radius: 16px;
    overflow: hidden;
    z-index: 2;
    background-color: ${(props) => props.theme.color.white};
    box-shadow: 0px 84px 124px 80px rgba(0, 0, 0, 0.25);
    width: max-content;

    ${(props) =>
        props.type === 'two-columns-submenu' &&
        `${SubMenuColumn}{
            min-width: 232px;
            max-width: 250px;
        }

        ${SubMenuItem}{
            margin-bottom: 30px;

            &:last-child {
                margin-bottom: 0
            }
        }`}

    ${(props) =>
        props.type === 'three-columns-submenu' &&
        `${SubMenuColumn}{
            min-width: 150px;
            max-width: 150px;
        }

        ${SubMenuItem}{
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0
            }
        }`}
`

export const FixedColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 50px;
        flex-direction: row;
    }
`

export const SubMenuItemLink = styled(Link)`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.p500};
    margin-bottom: 3px;
    text-decoration: none;
    display: inline-block;

    &:hover,
    &:focus {
        color: ${(props) => props.theme.color.a500};
    }
`

export const SubMenuItemDescription = styled.p`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
`

export const SubMenuColumnTitle = styled.div`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    margin-bottom: 20px;
`

export const NavItem = styled.div`
    &:hover ${NavItemLink}::after, &:focus ${NavItemLink}::after {
        display: block;
    }

    &:hover ${NavItemLinkLabel}::after, &:focus ${NavItemLinkLabel}::after {
        display: block;
    }

    &:hover ${SubMenuWrapper}, &:focus ${SubMenuWrapper} {
        display: block;
    }

    @media ${(props) => props.theme.query.desktop} {
        position: relative;
    }
`
